import React from 'react';
import usePageTitle from 'Routes/Overrides/routes/MerchantOverrides/hooks/usePageTitle';
import { RoleService } from 'Services';
import RulesHeader from 'Components/RulesHeader';
import DeployButtonSelector from 'Components/DeployButtonSelector';
import { shouldShowScheduledDeployment } from 'Selectors';
import DeleteMerchantBtn from './DeleteMerchantBtn/DeleteMerchantBtn';
import ActivateMerchantBtn from './ActivateMerchantBtn/ActivateMerchantBtn';

type Props = {
    merchantId: string;
    templateRepositoryId: number;
    disableLink?: boolean;
    isViewDeployedVisible?: boolean;
    canBeDeleted: boolean;
    merchantEnabled: boolean;
};

const Header = ({
    merchantId,
    templateRepositoryId,
    disableLink,
    canBeDeleted,
    merchantEnabled,
    isViewDeployedVisible
}: Props) => {
    const pageTitle = usePageTitle();
    return (
        <RulesHeader>
            <RulesHeader.Left
                title={pageTitle}
                disableLink={disableLink}
                isViewDeployedVisible={isViewDeployedVisible}
                isSandbox
                isMerchant
            />

            <RulesHeader.Right>
                {canBeDeleted
                    ? RoleService.isDesignAdmin() && (
                          <DeleteMerchantBtn merchantId={merchantId} templateRepositoryId={templateRepositoryId} />
                      )
                    : RoleService.isDesignAdmin() && (
                          <ActivateMerchantBtn
                              merchantId={merchantId}
                              templateRepositoryId={templateRepositoryId}
                              merchantEnabled={merchantEnabled}
                          />
                      )}
                <DeployButtonSelector
                    rulesType='merchantOverrides'
                    hasDeployAccess={RoleService.hasDeployAccess}
                    shouldShowScheduledDeployment={shouldShowScheduledDeployment()}
                />
            </RulesHeader.Right>
        </RulesHeader>
    );
};

export default React.memo(Header);
